import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { DropDownOption, ValueChangeEvent } from '@interfaces/form.interface';

@Component({
  selector: 'ark-ui-select',
  templateUrl: './ui-select.component.html',
  styleUrls: ['./ui-select.component.scss'],
})
export class UiSelectComponent {
  @Input() label!: string;
  @Input() placeholder = 'Select...';

  @Input() searchEnabled = false;
  @Input() searchPlaceholder = 'Search...';

  @Input() error = false;
  @Input() errorLabel!: string;

  private _items: DropDownOption[] = [];
  get items(): DropDownOption[] {
    return this._items;
  }
  @Input() set items(v: DropDownOption[]) {
    this._items = v;
    this.filteredItems = v;
  }

  filteredItems: DropDownOption[] = [];

  @Output() itemSelected = new EventEmitter<{
    event: ValueChangeEvent;
    option: DropDownOption;
  }>();

  @ViewChild('ref', { static: true })
  ref!: ElementRef;

  opened = false;
  selectedName!: string;

  searchTerm = '';

  constructor() {}

  toggle() {
    this.opened = !this.opened;
  }

  itemSelect(item: DropDownOption) {
    this.toggle();
    this.filteredItems.forEach((e) => (e.selected = false));
    item.selected = true;
    this.selectedName = item.name;

    this.searchFilter('');

    this.itemSelected.emit({
      event: { status: 'VALID', value: item.value },
      option: item,
    });
  }

  searchChange(e: any) {
    const value = e.target?.value as string;
    this.searchFilter(value);
  }
  searchFilter(value: string) {
    this.searchTerm = value;

    this.filteredItems = this._items.filter((e) =>
      e.name.toLowerCase().includes(value.toLowerCase()),
    );
  }

  @HostListener('document:click', ['$event.target'])
  public clickOutside(target: any): void {
    if (this.opened) {
      const inside = this.ref.nativeElement.contains(target);
      if (!inside) {
        this.opened = false;
        this.searchFilter('');
      }
    }
  }
}
